var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChefHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "_32",
    "data-name": 32
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.7392 5.4575a6.4919 6.4919 0 0 0 -11.4782 0 5.9871 5.9871 0 1 0 -4.261 11.1862v12.3563a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-12.3564a5.987 5.987 0 1 0 -4.2608-11.1861zm2.2608 22.5425h-16v-2h16zm.8027-13.08a1.0538 1.0538 0 0 0 -.8027.98v8.1h-16v-8.1a1.0546 1.0546 0 0 0 -.8022-.98 4.0007 4.0007 0 1 1 3.0122-7.255 1.024 1.024 0 0 0 1.5039-.5341 4.5 4.5 0 0 1 8.5727 0 1.0012 1.0012 0 0 0 .7069.66 1.0947 1.0947 0 0 0 .797-.1257 4.0008 4.0008 0 1 1 3.0122 7.2548z",
    fill: "#283159",
    "data-original": "#000000",
    className: ""
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHat);
export default __webpack_public_path__ + "static/media/chef-hat.7afb5e2ae4fb9e1eef6d2ea619c7c1a4.svg";
export { ForwardRef as ReactComponent };